<template>
  <Intro />
  <NetworkDoctors />
  <CostContainment />
  <CallCentreServices />
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/insurer/InsurerIntro.vue";
import NetworkDoctors from "@/components/insurer/NetworkDoctors.vue";
import CostContainment from "@/components/insurer/CostContainment.vue";
import CallCentreServices from "@/components/insurer/CallCentreServices.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

